import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type { generalTab, sipTab, queuesTab, endpointsTab, configSavedTabs } from "src/types";

const systemTheme = window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";

export const initialState: configSavedTabs = {
  general: {
    recordQuality: "default",
    sentryLogs: true,
    theme: systemTheme,
  },
  sip: {
    paNumber: "",
    manualConfiguration: false,
    internalUse: false,
  },
  queues: ["oculta"],
  endpoints: {
    paUploaderServerUrl: "",
    securityKey: "",
  },
};

const configSlice = createSlice({
  name: "config",
  initialState,
  reducers: {
    setGeneral: (state, action: PayloadAction<generalTab>) => {
      state.general = action.payload;
    },
    setSip: (state, action: PayloadAction<sipTab>) => {
      state.sip = action.payload;
    },
    setQueues: (state, action: PayloadAction<queuesTab>) => {
      state.queues = action.payload;
    },
    setEndpoint: (state, action: PayloadAction<endpointsTab>) => {
      state.endpoints = action.payload;
    },
    setPreviewTheme: (state, action: PayloadAction<string>) => {
      state.general.theme = action.payload;
    },
    setPaNumber: (state, action: PayloadAction<string>) => {
      state.sip.paNumber = action.payload;
    },
  },
});

export const { setGeneral, setSip, setQueues, setEndpoint, setPreviewTheme, setPaNumber } = configSlice.actions;

export default configSlice.reducer;
